export default {
  title: (state) => state.title,
};
